import React from 'react';
export function InfoLiner12() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 3.56253C6.5625 3.87319 6.31066 4.12503 6 4.12503C5.68934 4.12503 5.4375 3.87319 5.4375 3.56253C5.4375 3.25187 5.68934 3.00003 6 3.00003C6.31066 3.00003 6.5625 3.25187 6.5625 3.56253Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5.12503C6.20711 5.12503 6.375 5.29292 6.375 5.50003V8.87503C6.375 9.08214 6.20711 9.25003 6 9.25003C5.79289 9.25003 5.625 9.08214 5.625 8.87503V5.50003C5.625 5.29292 5.79289 5.12503 6 5.12503Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9998 0.112549C2.74823 0.112549 0.112305 2.74847 0.112305 6.00005C0.112305 9.25163 2.74823 11.8875 5.9998 11.8875C9.25138 11.8875 11.8873 9.25163 11.8873 6.00005C11.8873 2.74847 9.25138 0.112549 5.9998 0.112549ZM0.862305 6.00005C0.862305 3.16269 3.16244 0.862549 5.9998 0.862549C8.83717 0.862549 11.1373 3.16269 11.1373 6.00005C11.1373 8.83741 8.83717 11.1375 5.9998 11.1375C3.16244 11.1375 0.862305 8.83741 0.862305 6.00005Z",
    fill: "currentColor"
  }));
}